export const HELP_CENTER_URL = 'https://help.otter.ai/hc';

export const HELP_CENTER_ARTICLES = {
  INVITE_MEMBERS: `${HELP_CENTER_URL}/articles/360049123413-Invite-members-to-join-your-Workspace`,
  CONVERSATION_PAGE_OVERVIEW: `${HELP_CENTER_URL}/articles/5093228433687-Conversation-Page-Overview#h_01HNXZWNHJ62WNTN3WBM75ZWDY`,
  STOP_FROM_JOINING_MEETINGS: `${HELP_CENTER_URL}/articles/12906714808823-Stop-OtterPilot-from-automatically-joining-your-meetings`,
  CANCEL_OR_DOWNGRADE_ARTICLE: `${HELP_CENTER_URL}/articles/26011568967447-Will-I-still-have-access-to-my-conversations-if-I-cancel-downgrade-or-change-plans`,
} as const;

export const SALES_URL = 'https://otter.ai/sales';
export const PRICING_URL = 'https://otter.ai/pricing';
export const INTEGRATIONS_URL = 'https://otter.ai/integrations';
export const PRICING_DEMO_URL = 'https://otter.ai/pricing-demo';

export const TERMS_OF_SERVICE_URL = 'https://otter.ai/terms-of-service';
export const PRIVACY_POLICY_URL = 'https://otter.ai/privacy-policy';

export const MOBILE_PAYMENT_SUPPORT_URLS = {
  APPLE_HELP_ARTICLE: 'https://support.apple.com/en-us/HT202039',
  GOOGLE_HELP_ARTICLE:
    'https://support.google.com/googleplay/answer/7018481?hl=en&co=GENIE.Platform%3DAndroid&oco=1',
  APPLE_MANAGE_SUBSCRIPTIONS: 'https://apps.apple.com/account/subscriptions',
  GOOGLE_MANAGE_SUBSCRIPTIONS:
    'https://play.google.com/store/account/subscriptions',
} as const;

export const ZOOM_COMPLIANCE_LEARN_MORE_URL =
  'https://help.otter.ai/hc/en-us/articles/19504911385495-Zoom-compliance-requirements-for-OtterPilot';

export const HELP_CENTER_SUPPORT_FORM_URL =
  'https://help.otter.ai/hc/en-us/requests/new';

export const SALES_TAX_FAQ_URL =
  'https://help.otter.ai/hc/en-us/articles/26572931927959-Sales-Tax-FAQ';
